"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var BaseQuery_1 = require("./BaseQuery");
var applySubQueryPlaceholders_1 = require("../utils/applySubQueryPlaceholders");
var ValueQuery = /** @class */ (function (_super) {
    __extends(ValueQuery, _super);
    function ValueQuery() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ValueQuery.prototype.getOptions = function () {
        var _a = this.queryOptions, value = _a.value, subQueries = _a.subQueries, allSubQueryValuesRequired = _a.allSubQueryValuesRequired, _b = _a.options, options = _b === void 0 ? {} : _b;
        return __assign({ value: value,
            subQueries: subQueries,
            allSubQueryValuesRequired: allSubQueryValuesRequired }, (options.none || {}));
    };
    ValueQuery.prototype.getRawValue = function (executionOptions) {
        var _a = this.options, value = _a.value, subQueries = _a.subQueries, allSubQueryValuesRequired = _a.allSubQueryValuesRequired;
        return applySubQueryPlaceholders_1.applySubQueryPlaceholders({
            executionOptions: executionOptions,
            subQueries: subQueries,
            allSubQueryValuesRequired: allSubQueryValuesRequired,
            template: value,
        });
    };
    return ValueQuery;
}(BaseQuery_1.BaseQuery));
exports.ValueQuery = ValueQuery;
//# sourceMappingURL=ValueQuery.js.map